const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Abhas Jaiswal</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate Tech Head, UPES-CSI</li>
    <li>
        Passionate about cutting-edge technology and innovation.
    </li>
    <li>
        Leading technical projects and mentoring team members.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
